import { combineReducers } from 'redux';

import isLoading from './isLoading';
import url from './url';

/** @typedef {{ isLoading: boolean, url: string }} AuditsUIDetailsShareURLReducer */

export default combineReducers({
  isLoading,
  url,
});
